// Module dependencies
import { useState } from 'react';

export type UseBasicModalReturn = {
  showModal: boolean;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
};

export const useBasicModal = (): UseBasicModalReturn => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return {
    showModal,
    handleCloseModal,
    handleOpenModal,
  };
};
